import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsSearchOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-background-50/80 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="text-2xl font-bold font-heading text-primary-600 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              韩漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4">
            {isSearchOpen ? (
              <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2 transition-all duration-300">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索漫画..."
                  className="bg-transparent text-sm text-foreground-900 placeholder-foreground-400 outline-none w-40 focus:w-56 transition-all duration-300"
                  autoFocus
                />
                <button
                  onClick={() => { setIsSearchOpen(false); setSearchQuery(''); }}
                  className="w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-foreground-600 cursor-pointer"
                  aria-label="关闭搜索"
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>
            ) : (
              <button
                onClick={() => setIsSearchOpen(true)}
                className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
            )}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 text-foreground-600 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-lg ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-background-200/70 animate-[fadeIn_0.2s_ease-out]">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors duration-150 whitespace-nowrap"
              >
                首页
              </Link>
              {categories.slice(1, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors duration-150 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/category/all"
                className="px-4 py-3 text-sm font-medium text-primary-600 hover:bg-primary-50 rounded-lg transition-colors duration-150 whitespace-nowrap"
              >
                查看全部分类 →
              </Link>
              <Link
                to="/about"
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors duration-150 whitespace-nowrap"
              >
                关于我们
              </Link>
              <div className="px-4 pt-2">
                <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2.5">
                  <i className="ri-search-line text-foreground-400"></i>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="搜索漫画..."
                    className="bg-transparent text-sm text-foreground-900 placeholder-foreground-400 outline-none w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}